import { CheckIcon } from './icons'
import './StatusRing.css'

export type RingState = 'open' | 'waiting' | 'done'

interface StatusRingProps {
  state: RingState
  /** A CSS colour: the category's palette token, or none for grey. */
  color: string | null
  label: string
  onToggle?: () => void
  /** A preview or a past week's open card: the ring is not a control. A ticked row's always is. */
  inert?: boolean
  size?: 'card' | 'small' | 'mini'
}

/**
 * The ring: open, dashed while waiting, filled with a tick once done. It takes
 * the category colour with a light wash and sits in a 44px target; tapping it
 * ticks the task.
 */
export function StatusRing({ state, color, label, onToggle, inert = false, size = 'card' }: StatusRingProps) {
  const style = color ? ({ '--ring': color } as React.CSSProperties) : undefined
  const ring = (
    <span className={`ring ring--${state} ring--${size} ${color ? '' : 'ring--none'}`} style={style}>
      {state === 'done' && size !== 'mini' && <CheckIcon size={size === 'small' ? 10 : 12} weight={3.6} />}
    </span>
  )
  if (inert || !onToggle) {
    return label ? (
      <span className={`ring-slot ring-slot--${size}`} role="img" aria-label={label}>
        {ring}
      </span>
    ) : (
      <span className={`ring-slot ring-slot--${size}`} aria-hidden="true">
        {ring}
      </span>
    )
  }
  return (
    <button type="button" className={`ring-slot ring-slot--${size}`} aria-label={label} onClick={onToggle}>
      {ring}
    </button>
  )
}
